import { CollarType } from 'src/enums/nginr-type.enum';
import { PersonIdentified } from 'src/types/person.type';

export const convertPersonRecordToEditFormData = (editData: PersonIdentified) => {
  const collarType = editData.collar?.type;
  return {
    id: editData.id,
    whiteCollarId: collarType === CollarType.White_Collar ? editData.collarId : undefined,
    blueCollarId: collarType === CollarType.Blue_Collar ? editData.collarId : undefined,

    description: editData?.description ?? undefined,
    name: editData.name,
    email: editData.email,
    surname: editData.surname,
    status: editData.status,
    nationalityId: editData.nationalityId,
    weight: editData?.weight ?? undefined,
    height: editData.height,
    pictures: editData.pictures,
    organization: editData?.organization ?? undefined,
    // genderBitValue: editData.genderBitValue,
    genderId: editData.genderId,
    ageId: editData.ageId,
  };
};
